import { render } from "./kubernetes.svg?vue&type=template&id=0faae653?inline"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__